module.exports = __webpack_public_path__ + "static/media/S-task04_nodeLink.921a839d.png";